import { Heading, HFlow, VFlow } from 'bold-ui'
import React from 'react'
import { formatDate } from 'util/date/formatDate'
import StatusSquare from 'view/atendimentos/detail/historico/components/StatusSquare'
import { cuidadoCompartilhadoClassificacaoPrioridadeRecord } from 'view/atendimentos/detail/soap/plano/cuidado-compartilhado/model-cuidadocompartilhado'

import { ListaRegulacamTableItem } from '../../model-regulacao'

type RegulacaoModalItemProps = {
  item: ListaRegulacamTableItem
}

export const RegulacaoModalItemGuiaEncaminhamento = (props: RegulacaoModalItemProps) => {
  const { item } = props
  const { lotacao } = item
  const { ciap, cid10, classificacaoPrioridade, cbo, atendimentoProfissional } = item.guiaEncaminhamento
  const { label, mainColor } = cuidadoCompartilhadoClassificacaoPrioridadeRecord[classificacaoPrioridade]

  return (
    <VFlow vSpacing={0.5}>
      {renderItem('CBO', cbo.nome)}
      {renderItem(
        'Solicitante',
        [lotacao.profissional.nome, lotacao.cbo.nome, lotacao.equipe?.nome ?? 'Sem equipe', lotacao.unidadeSaude.nome]
          .filterNotNull()
          .join(' | ')
      )}

      <VFlow vSpacing={0}>
        <Heading level={5} fontWeight='bold'>
          Problemas e condições
        </Heading>
        <Heading level={5} fontWeight='normal'>
          <VFlow vSpacing={0}>
            {ciap && `${ciap.descricao} - ${ciap.codigo} (CIAO2)`}
            {cid10 && `${cid10.nome} - ${cid10.codigo} (CID10)`}
          </VFlow>
        </Heading>
      </VFlow>

      {renderItem('Discussão', item.ultimaEvolucao.observacao ?? '-')}
      <HFlow hSpacing={2}>
        <VFlow vSpacing={0}>
          <Heading level={5} fontWeight='bold'>
            Prioridade
          </Heading>
          <StatusSquare color={mainColor} description={label} />
        </VFlow>
        {renderItem('Data da solicitação', formatDate(atendimentoProfissional.finalizadoEm))}
      </HFlow>
    </VFlow>
  )
}

const renderItem = (title: string, subtitle: string) => (
  <VFlow vSpacing={0}>
    <Heading level={5} fontWeight='bold'>
      {title}
    </Heading>
    <Heading level={5} fontWeight='normal'>
      {subtitle}
    </Heading>
  </VFlow>
)
